import React from 'react';
import { Modal } from './ui/Modal';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos y Condiciones" data-id="element-312">
      <div className="prose prose-sm max-w-none text-gray-700 space-y-6" data-id="element-313">
        <p className="text-sm text-gray-500 italic" data-id="element-314">
          Última actualización: Enero 2025
        </p>

        <section data-id="element-315">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-316">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-317">
            Al acceder y realizar la compra de "Casa Impecable con 2
            Ingredientes", aceptas estar legalmente vinculado por estos términos
            y condiciones. Si no estás de acuerdo con alguna parte de estos
            términos, no debes realizar la compra.
          </p>
        </section>

        <section data-id="element-318">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-319">
            2. Descripción del Producto
          </h3>
          <p data-id="element-320">
            "Casa Impecable con 2 Ingredientes" es un producto digital (ebook)
            que incluye:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-321">
            <li data-id="element-322">Ebook principal en formato PDF</li>
            <li data-id="element-323">Bono 1: Checklist de 15 Minutos por Habitación (PDF)</li>
            <li data-id="element-324">Bono 2: Antídoto Contra la Culpa (PDF)</li>
            <li data-id="element-325">Bono 3: La Compañera Invisible (PDF)</li>
            <li data-id="element-326">Materiales complementarios (checklists, calendarios)</li>
          </ul>
        </section>

        <section data-id="element-327">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-328">
            3. Precio y Pago
          </h3>
          <p data-id="element-329">
            El precio actual es de $9.97 USD (oferta especial de temporada). Los
            precios están sujetos a cambios sin previo aviso. El pago se procesa
            de forma segura a través de nuestros procesadores de pago
            autorizados.
          </p>
        </section>

        <section data-id="element-330">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-331">
            4. Entrega del Producto
          </h3>
          <p data-id="element-332">
            Tras completar el pago, recibirás acceso inmediato al producto
            digital vía correo electrónico. Los enlaces de descarga estarán
            disponibles durante 30 días desde la fecha de compra. Es tu
            responsabilidad descargar y guardar los archivos.
          </p>
        </section>

        <section data-id="element-333">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-334">
            5. Garantía de Devolución de 30 Días
          </h3>
          <p data-id="element-335">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecha con el producto, puedes solicitar un reembolso completo
            dentro de los 30 días posteriores a la compra enviando un correo a
            soporte@casaimpecable.com. No se requieren explicaciones.
          </p>
        </section>

        <section data-id="element-336">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-337">
            6. Propiedad Intelectual
          </h3>
          <p data-id="element-338">
            Todo el contenido de "Casa Impecable con 2 Ingredientes" está
            protegido por derechos de autor. Al comprar, obtienes una licencia
            de uso personal no transferible. No está permitido:
          </p>
          <ul className="list-disc pl-6 space-y-1" data-id="element-339">
            <li data-id="element-340">Compartir, distribuir o revender el contenido</li>
            <li data-id="element-341">Reproducir el material para uso comercial</li>
            <li data-id="element-342">Modificar o crear obras derivadas sin autorización</li>
          </ul>
        </section>

        <section data-id="element-343">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-344">
            7. Limitación de Responsabilidad
          </h3>
          <p data-id="element-345">
            El contenido de este ebook es solo para fines informativos y
            educativos. Los resultados pueden variar según cada persona. No nos
            hacemos responsables de daños directos, indirectos o consecuentes
            derivados del uso del producto.
          </p>
        </section>

        <section data-id="element-346">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-347">
            8. Modificaciones
          </h3>
          <p data-id="element-348">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor inmediatamente después
            de su publicación en nuestro sitio web.
          </p>
        </section>

        <section data-id="element-349">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-350">9. Contacto</h3>
          <p data-id="element-351">
            Para cualquier pregunta sobre estos términos, contáctanos en:
            <br data-id="element-352" />
            Email: soporte@casaimpecable.com
            <br data-id="element-353" />
            Desarrollado por Emily Graterol
          </p>
        </section>
      </div>
    </Modal>;
}